import * as apiGetDetails from 'api/shoppingCart/GetShoppingCartGetDetailsIdV1';
import EntityType from 'types/ShoppingCart/EntityType';
import * as Translation from 'types/_general/Translation';

export * as Appearance from 'types/ShoppingCart/Appearance';

export type Type = {
	id: string;
	type: EntityType;
	name: Translation.Type<string>;
	quantity: number;
};

export function create(): Type {
	return {
		id: '',
		type: EntityType.RECIPE,
		name: {},
		quantity: 0,
	};
}

export function getUrl(obj: Type): string {
	switch (obj.type) {
		case EntityType.MENUPLAN:
			return '/menuPlan/detail/' + obj.id;
		case EntityType.MENU:
			return '/menu/detail/' + obj.id;
		default:
			return '/recipe/detail/' + obj.id;
	}
}

export function mapFromApi(input: apiGetDetails.Appearances): Type {
	return {
		id: input.entityId,
		type: input.entityType as EntityType,
		name: input.nameTranslation,
		quantity: input.quantity,
	};
}
